// extracted by mini-css-extract-plugin
export default {"caption":"gCVIkcBj","blockContent":"T5kZba8j","infoBlock":"z5Yq6gyG","mobile":"mobile"};